import { CallRecordingSetting } from './call-recording';
import { EndCallSilenceSetting } from './end-call-silence';
import { MaxCallDurationSetting } from './max-call-duration';
import { RingDurationSetting } from './ring-duration';

export const CallSettingsTab = () => {
  return (
    <>
      <CallRecordingSetting />
      <RingDurationSetting />
      <MaxCallDurationSetting />
      <EndCallSilenceSetting />
    </>
  );
};
